import React, {Component} from 'react';
import homeBg from './PageTitle-home-bg.jpg';
import './PageTitle.css';


export default class extends Component {
    render() {
        return (
            <header className="masthead" style={{backgroundImage: `url(${homeBg})`}} >
                <div className="overlay"/>
                <div className="container">
                    <div className="row">
                        <div className="col-lg-8 col-md-10 mx-auto">
                            <div className="site-heading">
                                <h1>胡中元 @ 腾讯微博</h1>
                                <span className="subheading">记录着 2010 年初三至 2016 年大二</span>
                            </div>
                        </div>
                    </div>
                </div>
            </header>
        )
    }
}



// WEBPACK FOOTER //
// ./src/head-and-foot/PageTitle.js